import { render, staticRenderFns } from "./SchoolClass.vue?vue&type=template&id=7e59f7fe&scoped=true"
import script from "./SchoolClass.vue?vue&type=script&lang=js"
export * from "./SchoolClass.vue?vue&type=script&lang=js"
import style0 from "./SchoolClass.vue?vue&type=style&index=0&id=7e59f7fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e59f7fe",
  null
  
)

export default component.exports